import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { ACCENT_COLOR } from '@/constants/colors';

interface SectionHeadingProps {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string;
  /** Whether to show a bottom divider (default: true). */
  divider?: boolean;
  children?: React.ReactNode;
}

/**
 * SectionHeading — Reusable section header with icon, title, optional subtitle,
 * optional right-aligned children, and a bottom divider.
 */
const SectionHeading: React.FC<SectionHeadingProps> = ({
  icon,
  title,
  subtitle,
  divider = true,
  children,
}) => (
  <Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5 }}>
      {icon && (
        <Box sx={{ display: 'flex', color: ACCENT_COLOR, fontSize: 18 }}>
          {icon}
        </Box>
      )}
      <Typography
        variant="body2"
        sx={{ fontWeight: 700, color: ACCENT_COLOR, lineHeight: 1.3 }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
          {subtitle}
        </Typography>
      )}
      <Box sx={{ flex: 1 }} />
      {children}
    </Box>
    {divider && <Divider sx={{ mb: 1 }} />}
  </Box>
);

export default React.memo(SectionHeading);
